import { sendEvent } from "../modules/helpers/Analytics";
import { ApiServiceBase } from "./apiServiceBase";

export class CoverageService extends ApiServiceBase {
  private apiUrl = "/api/watchdocuments/1.0";

  getCoverageCategories(
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ): JQuery.jqXHR {
    return this.get(this.apiUrl + "/category", onSuccess, onFailure);
  }

  addCoverage(
      pageId: number,
      pageName: string,
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ): JQuery.jqXHR {
      sendEvent('addCoverage', undefined, { pageTitle: pageName })
    return this.post(this.apiUrl, onSuccess, onFailure, `=${pageId}`);
  }

  getCoverages(
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ): JQuery.jqXHR {
    return this.get(this.apiUrl, onSuccess, onFailure);
  }

  getFilteredCoverage(
    filter: string,
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ): JQuery.jqXHR {
    return this.get(this.apiUrl + "?filter=" + filter, onSuccess, onFailure);
  }

  getFilteredCoverageByCategory(
    filter: string,
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ): JQuery.jqXHR {
    return this.get(
      this.apiUrl + "/category?filter=" + filter,
      onSuccess,
      onFailure
    );
  }

  deleteCoverageById(
    coverageId: number,
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ): JQuery.jqXHR {
    return this.delete(`${this.apiUrl}/${coverageId}`, onSuccess, onFailure);
  }

  getUpdatedWatchedPages(
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ): JQuery.jqXHR {
    return this.get(`${this.apiUrl}/updated`, onSuccess, onFailure);
  }

  addWatchOfCategory(
    categoryId: number,
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ): JQuery.jqXHR {
    return this.post(
      `${this.apiUrl}/category`,
      onSuccess,
      onFailure,
      `=${categoryId}`
    );
  }

  addWatchOfParentCategory(
    categoryId: number,
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ): JQuery.jqXHR {
    return this.post(
      `${this.apiUrl}/category/parent/`,
      onSuccess,
      onFailure,
      `=${categoryId}`
    );
  }

  deleteWatchOfCategory(
    categoryId: number,
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ): JQuery.jqXHR {
    return this.delete(
      `${this.apiUrl}/category/${categoryId}`,
      onSuccess,
      onFailure
    );
  }

  deleteWatchOfParentCategory(
    categoryId: number,
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ): JQuery.jqXHR {
    return this.delete(
      `${this.apiUrl}/category/parent/${categoryId}`,
      onSuccess,
      onFailure
    );
  }
}
